import { F0Button } from '@factorialco/f0-react'
import { Stack } from '@factorialco/f0-react/dist/experimental'

import Callout from 'modules/core/components/Callout'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

interface ConfirmationModalProps {
  onClose: () => void
  onSubmit: () => void
}

export function ConfirmationModal({ onClose, onSubmit }: ConfirmationModalProps) {
  const { getDataCollectionSource, configuration, capabilityMode } =
    usePrivateIntegrationsSyncContext()

  // TODO: improve this ugly list of keys to exclude
  // we need to exclude these keys from the dataCollectionMappedVariables as they are not relevant for the user
  const excludedKeys = [
    'payrollRunId',
    'marketplaceIntegrationId',
    'includeSyncableState',
    'companyId',
    'sortOrder',
    'integrationsAgreggatedSyncableStates',
    'companyIdString',
    'includeGrouped',
    'includeManualDrafts',
    'from',
    'to',
  ]

  // TODO: move this to SyncContext
  const hasFiltersApplied = () => {
    const dataCollectionSource = getDataCollectionSource()
    if (!dataCollectionSource?.mappedVariables) {
      return false
    }

    const filteredVariables = Object.entries(dataCollectionSource.mappedVariables).filter(
      ([key, value]) => !excludedKeys.includes(key) && value !== undefined && value !== null
    )

    return filteredVariables.length > 0
  }

  const isExportMode = capabilityMode === 'file'

  const isCompensations = configuration.origin === 'compensations'

  const title = isExportMode
    ? i18n.t('integrations.confirmation_modal.export_title')
    : i18n.t('integrations.confirmation_modal.sync_title')

  const description = () => {
    const items = isCompensations
      ? i18n.t('integrations.confirmation_modal.compensations_items')
      : i18n.t('integrations.confirmation_modal.expenses_items')

    return isExportMode
      ? i18n.t('integrations.confirmation_modal.export_description', { items })
      : i18n.t('integrations.confirmation_modal.sync_description', { items })
  }

  const labelCta = isExportMode
    ? i18n.t('integrations.confirmation_modal.export_cta')
    : i18n.t('integrations.confirmation_modal.sync_cta')

  const cancelCta = i18n.t('integrations.confirmation_modal.cancel_cta')

  const filtersCalloutTitle = i18n.t('integrations.confirmation_modal.filters_callout.title')

  const filtersCalloutDescription = i18n.t(
    'integrations.confirmation_modal.filters_callout.description'
  )

  const expensesCalloutTitle = i18n.t('integrations.confirmation_modal.expenses_callout.title')

  const expensesCalloutDescription = i18n.t(
    'integrations.confirmation_modal.expenses_callout.description'
  )

  return (
    <Modal
      title={title}
      description={description()}
      illustration="sync"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <F0Button onClick={onClose} variant="outline" label={cancelCta} />
          <F0Button variant="default" label={labelCta} />
        </>
      }
    >
      <Stack gap="4">
        {hasFiltersApplied() && (
          <Callout
            type="warning"
            title={filtersCalloutTitle}
            description={filtersCalloutDescription}
          />
        )}

        {!isCompensations && (
          <Callout
            type="warning"
            title={expensesCalloutTitle}
            description={expensesCalloutDescription}
          />
        )}
      </Stack>
    </Modal>
  )
}
